import { render } from "./IconTrekThrottle.vue?vue&type=template&id=0c04e340"
import script from "./IconTrekThrottle.vue?vue&type=script&lang=js"
export * from "./IconTrekThrottle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__